import { makePaginatedSearch } from "api/makeApiRequestType/makePaginatedSearch";
import { formatDataForGetRequest } from "api/utils/formatDataForGetRequest";
import {
	SingleSessionPrice,
	flagValidationErrorsInSingleSessionPrice
} from "types-and-validators/SingleSessionPrice";

export type OutputRow = SingleSessionPrice;

type Params = {
	uid: string;
	sessionTypeId: string;

	showDisabled?: boolean;
	includePricesForGuestUid?: string;
};

export const getSingleSessionPrices = makePaginatedSearch<Params, OutputRow>({
	endPoint: "singleSessionPrices",
	flagValidationErrorsInRow: flagValidationErrorsInSingleSessionPrice,
	preProcessor: input => formatDataForGetRequest(input, false)
});
